export const labels = {
	logo: {
		label: "Label.MobileCreator.Header.Logo",
		default: "", // Default no logo, logo is loaded at the start, together with lots of other CMS labels.
	},

	shortLogo: {
		label: "Label.MobileCreator.Header.ShortLogo",
		default: "",
	},
};
